export default __webpack_public_path__ + "static/moving_table-16e6758e9268a619cc07794fd4b8c776.jpg";